import './studymaterialcard.css';
import '../DOC/docCard.css';
import StudymDoc from './studymDoc';
import React, { useEffect, useState } from 'react';

const CardView = (props) => {
  const [documentList, setDocumentList] = useState([]);

  useEffect(() => {
    if (Array.isArray(props.globalDocuments)) {
      const updatedDocs = props.globalDocuments.map((doc) => ({
        ...doc,
        isMarked: !!doc.isMarked,
        isLocked: doc.isLocked,
      }));
      setDocumentList(updatedDocs);
    }
  }, [props.globalDocuments]);

  const handleMarkAsComplete = (index) => {
    setDocumentList((prev) => {
      const updated = [...prev];
      updated[index].isMarked = true;
      if (index + 1 < updated.length) {
        updated[index + 1].isLocked = false;
      }
      return updated;
    });

    if (props.handleMarkAsComplete) {
      props.handleMarkAsComplete(index);
    }
  };

  const handleFileOpen = (el, type) => {
    const fileName = el?.file_name ?? '';
    const ext = fileName.split('.').pop().toLowerCase();

    const imageTypes = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
    const audioTypes = ['mp3', 'aac', 'wav', 'ogg'];
    const documentTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'];

    if (imageTypes.includes(ext)) {
      props.image(el);
    } else if (audioTypes.includes(ext)) {
      props.listen(el);
    } else if (documentTypes.includes(ext)) {
      props.view(el);
    } else if (type === 'VDOCipher' || (el.videoID && el.is_vdocipher)) {
      props.vdocipherApicalling(el);
    } else if (type === 'Vimeo' || (el.videoID && el.is_vimeo)) {
      props.vimeo(el);
    } else if (type === 'YoutubeURL' || el.youtubeVideoID) {
      props.youtubeVideo(el);
    } else {
      props.view(el);
    }
  };


  return (
    <div>
      {documentList.map((data, index) => {
        const show =
          (props.topicId === 0 || props.topicId === data.topic_id) &&
          (props.search === '' || data.title?.toUpperCase().includes(props.search.toUpperCase()));

        return (
          show && (
            <StudymDoc
              key={index}
              el={data}
              index={index}
              institute_id={props.institute_id}
              student_id={props.student_id}
              user_id={props.user_id}
              student_auth={props.student_auth}
              heading_name={data.title}
              date={data.student_file_share_date}
              type={data.type}
              file_name={data?.file_name ?? ''}
              topic={data.topic_name}
              category_name={data.category_name}
              download={props.download}
              view={props.view}
              downloadvimeo={props.downloadvimeo}
              UpdatVimeoWatchCall={props.UpdatVimeoWatchCall}
              vdocipherApicalling={props.vdocipherApicalling}
              youtubeVideo={props.youtubeVideo}
              vimeo={props.vimeo}
              image={props.image}
              listen={props.listen}
              is_readonly={data.is_readonly}
              handleClick={handleFileOpen}
              vimeo_video_downlodable={props.subjectData?.vimeo_video_downlodable}
              video_url={data.video_url}
              posterUrl={data.posterUrl}
              posterList={data.posterList}
              isLocked={data.isLocked}
              isMarked={data.isMarked}
              onMarkComplete={() => handleMarkAsComplete(index)}
            />
          )
        );
      })}
    </div>
  );
};

export default CardView;
